import React, { useContext } from 'react';

import ResourceDetail from 'app/components/Resources/ResourceDetail';
import { ChevronLeft } from 'app/components/shared/icons';
import BestOfCategoryIcon from 'app/features/BestOf/presentation/BestOfCategoryIcon';
import BestOfSubmissionCategoryBanner from 'app/features/BestOf/submission/BestOfSubmissionCategoryBanner';

import { ResourceSubmissionContext } from '../ResourceSubmissionContext';
import {
  ResourceSubmissionPreviewGoBackButton,
  ResourceSubmissionPreviewGoBackButtonText,
  ResourceSubmissionPreviewTitle,
  ResourceSubmissionPreviewTitleWrapper,
  ResourceSubmissionPreviewWrapper,
  ResourceSubmissionPreviewCategory,
} from './styled';

export default function ResourceSubmissionPreview() {
  const { resource, setIsPreviewing, submissionCategory, bestOfYear } =
    useContext(ResourceSubmissionContext);
  const categoryBanner =
    submissionCategory && bestOfYear && bestOfYear !== 2025 ? (
      <BestOfSubmissionCategoryBanner categoryName={submissionCategory.name} />
    ) : undefined;
  const handleGoBack = () => {
    setIsPreviewing(false);
  };

  return (
    <ResourceSubmissionPreviewWrapper>
      <ResourceSubmissionPreviewGoBackButton onClick={handleGoBack}>
        <ChevronLeft width={8} height={14} fill="var(--color-primary)" />
        <ResourceSubmissionPreviewGoBackButtonText>
          EDIT SUBMISSION
        </ResourceSubmissionPreviewGoBackButtonText>
      </ResourceSubmissionPreviewGoBackButton>
      <ResourceSubmissionPreviewTitleWrapper>
        <ResourceSubmissionPreviewTitle>
          Submission preview: is everything looking good?
        </ResourceSubmissionPreviewTitle>
      </ResourceSubmissionPreviewTitleWrapper>
      {!categoryBanner && submissionCategory ? (
        <ResourceSubmissionPreviewCategory aria-label="Submission category">
          <span aria-hidden="true">
            <BestOfCategoryIcon src={submissionCategory.icon} />
          </span>
          <span>Submitted in: {submissionCategory.name}</span>
        </ResourceSubmissionPreviewCategory>
      ) : null}
      <ResourceDetail
        existingResource={resource}
        isFormPreview
        voteAction={categoryBanner}
        preventShowEditing
        hideShareLink={!resource?.slug}
      />
    </ResourceSubmissionPreviewWrapper>
  );
}
